<template>
    <section class="checkin-detail-timing" v-if="hasTimingFinishData || hasTimingPace || hasTimerName">
        <div class="checkin-detail-timing__data-item col" v-if="hasTimingFinishData">
            <h2>{{ $t('pages.checkins_detail.timing_finish_time') }}</h2>
            <p>
                <span class="checkin-detail-timing__data__value">{{ timingData.finish_time }}</span>
            </p>
        </div>

        <div class="checkin-detail-timing__data-item col" v-if="hasTimingPace">
            <h2>{{ $t('pages.checkins_detail.timing_pace') }}</h2>
            <p>
                <span class="checkin-detail-timing__data-item__value">{{ timingData.pace_value }}</span>
                <span class="checkin-detail-timing__data-item__unit">{{ timingData.pace_unit }}</span>
            </p>
        </div>

        <div class="checkin-detail-timing__data-item col" v-if="hasTimerName">
            <h2>{{ $t('pages.checkins_detail.timing_service') }}</h2>
            <p><span class="checkin-detail-timing__data-item__value">{{ timingData.timer_name }}</span></p>
        </div>

        <div class="checkin-detail-timing__data-item col" v-if="photoService">
            <p class="d-inline-block"><span class="checkin-detail-timing__data-item__value">{{ photoService }}</span></p>
        </div>
    </section>

    <section class="checkin-detail-timing" v-else-if="photoService">
        <div class="checkin-detail-timing__data-item col">
            <p class="d-inline-block"><span class="checkin-detail-timing__data-item__value">{{ photoService }}</span></p>
        </div>
    </section>
</template>


<script>
    export default {
        props: {
            timingData: {type: Object, required: false},
            photoService: {type: String},
        },

        methods: {
            containsKey(obj, key) {
                return obj !== null && Object.keys(obj).includes(key)
            }
        },

        computed: {
            hasTimingFinishData() {
                return this.containsKey(this.timingData, 'finish_time')
            },

            hasTimingPace() {
                return this.containsKey(this.timingData, 'pace_value')
            },

            hasTimerName() {
                return this.containsKey(this.timingData, 'timer_name')
            }
        }
    }
</script>
